<app-stages [stages]="stages" currentStage="Lokalizacja">
</app-stages>
<br>
@if (!pending() && !loading()) {
  <form autocomplete="off" novalidate [formGroup]="form" (ngSubmit)="submitAndGoNext()">
    <br>
    <app-exposed-map-control #expMap [control]="form.geometry">
    </app-exposed-map-control>
    <app-road-controls-set [expMapDict]="expMap.dictEvent()" [form]="form">
    </app-road-controls-set>
    <br>
    <app-parcels-crud [expMapDict]="expMap.dictEvent()" formControlName="parcels">
    </app-parcels-crud>
    <div class="row">
      <div class='col-12'>
        <div class='form-group' *ngIf='"description" as controlName'>
          <label [for]='controlName'>
            Uwagi ogólne oraz dotyczące oznakowania dróg *
          </label>
          <textarea
            rows="5"
            [id]='controlName'
            [ngClass]='{ "is-invalid": form.showError(controlName) }'
            [formControlName]='controlName'
            placeholder='Wpisz tu uwagi'></textarea>
          <app-validation-errors [control]='form.get(controlName)'>
          </app-validation-errors>
        </div>
      </div>
    </div>
  </form>
  <div class='application-actions'>
    <button
      [disabled]="pending()"
      (click)="onCancel()"
      type='button'
      class='btn btn-secondary'>
        <span>
          Wstecz
        </span>
    </button>
    <button
      (click)="submitAndGoNext()"
      [disabled]="pending()"
      type='button'
      class='btn btn-primary'>
      <span>Zapisz i przejdź dalej</span>
    </button>
  </div>
} @else {
  <app-spinner>
    {{ pending() ? 'Poczekaj trwa zapisywania danych...' : 'Poczekaj trwa ładowanie danych...' }}
  </app-spinner>
}
